import { Button } from 'reactstrap'
import { Link } from 'react-router-dom'
import PropTypes from 'prop-types'
import PriceUtil from 'utils/price-util'
import {
  CustomerRefundStatusBadge,
  CustomerRefundMethodBadge
} from 'domains/customer-refund/atoms'
import TimeUtil from 'utils/time-util'
import StringUtil from 'utils/string-util'

const propTypes = {
  refund           : PropTypes.object,
  to               : PropTypes.func,
  actionButtonText : PropTypes.string
}

const defaultProps = {
  actionButtonText: 'Detail'
}

/**
 * Row to show some attribute of ::Customer::Refund
 * @param {Object} refund - Customer::Refund
 * @param {Function} to - Function that decide where action button redirect to
 * @param {String} actionButtonText - Action Button Label
 */

const CustomerRefundUrlParamsTableRow = ({
  refund,
  to,
  actionButtonText
}) => (
  <tr>
    <td>{ refund.number }</td>
    <td>{ PriceUtil.format(refund.paid_item_price) }</td>
    <td>{ refund.quantity }</td>
    <td>{ <CustomerRefundStatusBadge status={ refund.status } /> }</td>
    <td>{ <CustomerRefundMethodBadge status={ refund.refund_method } /> }</td>
    <td>{ TimeUtil.format(refund.created_at) }</td>
    <td>{ StringUtil.humanize(refund.resolution_action) }</td>
    <td>{ StringUtil.humanize(refund.initiated_by) }</td>
    <td>{ refund.customer.name }</td>
    <td>{ refund.product.sku }</td>
    <td>
      <img
        style={{ width: '8rem' }}
        src={ refund.product.image }
        alt={ refund.product.name }
      />
    </td>

    <td>
      <Button
        color='primary'
        tag={ Link }
        size='sm'
        to={ to(refund.id) }
      >
        { actionButtonText }
      </Button>

    </td>

  </tr>
)

CustomerRefundUrlParamsTableRow.propTypes    = propTypes
CustomerRefundUrlParamsTableRow.defaultProps = defaultProps

export default CustomerRefundUrlParamsTableRow